import {
  behaviorAnalysisDetailCols,
  caregiverAuditDetailCols,
  incidentLists,
  pressureUlcerStagingDetailCols,
  repeatFallCols,
  woundAnalysisDetailCols,
} from "../dummyData/colums";

// Column defs hold formatter functions, so the snapshot stores a key and rebuilds them.
const DRILLDOWN_COLS: Record<string, () => any[]> = {
  incidentList: incidentLists,
  repeatFall: () => repeatFallCols(true),
  caregiverAudit: caregiverAuditDetailCols,
  wound: woundAnalysisDetailCols,
  pressureUlcerStaging: pressureUlcerStagingDetailCols,
  behavior: behaviorAnalysisDetailCols,
};

const signature = (cols: any[] = []) =>
  cols.map((col) => `${col.accessor}:${col.Header}`).join("|");

export const getDrilldownColsKey = (tableCols: any[] = incidentLists()) =>
  Object.keys(DRILLDOWN_COLS).find(
    (key) => signature(DRILLDOWN_COLS[key]()) === signature(tableCols)
  );

export const buildDrilldownCols = (colsKey: string) =>
  (DRILLDOWN_COLS[colsKey] ?? incidentLists)();
